import React from 'react';
import PropertyCard from '../../../components/property/property-card/PropertyCard';
import { Listing } from '../../../components/property/property-card/PropertyCardTypes';

interface PropertyGridProps {
  listings: Listing[];
  bookmarkedListings: number[];
  onBookmarkToggle: (id: number) => void;
  onShare: (listing: Listing) => void;
  onListingView: (listing: Listing) => void;
}

const PropertyGrid: React.FC<PropertyGridProps> = ({
  listings,
  bookmarkedListings,
  onBookmarkToggle,
  onShare,
  onListingView
}) => {
  return (
    <>
      <p className="text-lg md:text-xl font-medium mb-6">Featured properties</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {listings.map((listing, index) => (
          <div key={listing.id} onMouseEnter={() => onListingView(listing)}>
            <PropertyCard
              listing={listing}
              isBookmarked={bookmarkedListings.includes(listing.id)}
              onBookmarkToggle={onBookmarkToggle}
              onShare={() => onShare(listing)}
              isTopViewed={index < 3} // Add top viewed flag for first 3 properties
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default PropertyGrid;
